/* v8 ignore file -- @preserve */
// only for development
import { Directive, Input, TemplateRef } from '@angular/core'

@Directive({ selector: 'ng-template[typedTemplate]' })
export class TypedTemplateDirective<TypeToken> {
  @Input('typedTemplate')
  public typeToken!: TypeToken

  public constructor(
    private readonly contentTemplate: TemplateRef<TypeToken>
  ) {}
  public static ngTemplateContextGuard<TypeToken>(
    dir: TypedTemplateDirective<TypeToken>,
    ctx: unknown
  ): ctx is TypeToken {
    return true
  }
}
